import { createContext } from 'react';
import type { CmsSlotsList } from '../../utils/amplience/types';

export const CmsSlotsContext = createContext<CmsSlotsList>({} as CmsSlotsList);
